module.exports = __webpack_public_path__ + "img/appstore-badge-uk-black.0669a767.svg";